// extracted by mini-css-extract-plugin
export default {"routerIndexHeader":"style_routerIndexHeader__GxaA3","name":"style_name__WhKvD","title":"style_title__VwSI6","subTitle":"style_subTitle__4Caq-"};